 
<template>
  <div class="download-page">
    <!-- 四模块整屏滚动：模块一/三灰色背景，模块二白色，模块四为下载教程视频 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">

          <!-- ============ 模块一（灰色背景）：左侧文字 + 左下二维码 + 右侧手机图 ============ -->
          <div v-if="item.key === 'hero'" class="mod1-layout">
            <!-- 左侧文字区：大标题 + 副标题 + 介绍段落 -->
            <div class="mod1-text">
              <h2 class="mod1-title">{{ $t('download.title') }}</h2>
              <div class="mod1-subtitle">{{ $t('download.subtitle') }}</div>
              <p class="mod1-desc">{{ $t('download.desc') }}</p>
            </div>
            <!-- 左下角二维码白块（仅包图） -->
            <div class="mod1-chapp">
              <img class="mod1-chapp-img" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-1-INTAPP.png') : require('../assets/images/download/download-1-CHAPP.png')" alt="下载二维码">
            </div>
            <!-- 二维码下方提示文字（独立于白块，单独定位） -->
            <div class="mod1-chapp-tip">{{ $t('download.scanTip') }}</div>
            <!-- 模块一右侧手机图；英文版切换为 download-1-INTphone.png，中文保持原图 -->
            <img class="mod1-phone" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-1-INTphone.png') : require('../assets/images/download/download-1-phone.png')" alt="">
          </div>

          <!-- ============ 模块二（白色背景）：标题 + 手机图 + 左右各两张功能截图 ============ -->
          <div v-if="item.key === 'intro'" class="mod2-layout">
            <!-- 顶部标题区 -->
            <div class="mod2-header">
              <h2 class="mod2-title">{{ $t('download.mod2Title') }}</h2>
              <div class="mod2-divider"></div>
              <p class="mod2-subtitle">{{ $t('download.mod2Subtitle') }}</p>
            </div>
            <!-- 下方三列：1/4左 | 手机 | 3/2右 -->
            <div class="mod2-cols">
              <!-- 左容器：功能1+4 -->
              <div class="mod2-col-left">
                <div class="mod2-text mod2-text-1">{{ stripNewlines($t('download.feature1')) }}</div>
                <img class="mod2-card-1" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-1INT.png') : require('../assets/images/download/download-2-1.png')" alt="">
                <div class="mod2-text mod2-text-4">{{ stripNewlines($t('download.feature4')) }}</div>
                <img class="mod2-card-4" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-4INT.png') : require('../assets/images/download/download-2-4.png')" alt="">
              </div>
              <!-- 中间列：手机图；英文版切换为 download-2-INTphone.png -->
              <div class="mod2-col-center">
                <img class="mod2-phone" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-INTphone.png') : require('../assets/images/download/download-2-phone.png')" alt="">
              </div>
              <!-- 右容器：功能3+2 -->
              <div class="mod2-col-right">
                <div class="mod2-text mod2-text-3">{{ stripNewlines($t('download.feature2')) }}</div>
                <img class="mod2-card-3" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-3INT.png') : require('../assets/images/download/download-2-3.png')" alt="">
                <div class="mod2-text mod2-text-2">{{ stripNewlines($t('download.feature3')) }}</div>
                <img class="mod2-card-2" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-2INT.png') : require('../assets/images/download/download-2-2.png')" alt="">
              </div>
            </div>
          </div>

          <!-- ============ 模块三（灰色背景）：标题 + 四张悬浮展开的功能卡片 ============ -->
          <div v-if="item.key === 'feature'" class="mod3-layout">
            <h2 class="mod3-title">{{ $t('download.mod3Title') }}</h2>
            <div class="mod3-divider"></div>
            <p class="mod3-subtitle">{{ $t('download.mod3Subtitle') }}</p>
            <div class="mod3-list">
              <div
                v-for="(card, index) in mod3Cards"
                :key="index"
                class="mod3-card"
                :class="{ active: activeCard === index }"
                @mouseenter="activeCard = index"
              >
                <img class="mod3-card-bg" :src="card.bg" alt="">
                <div class="mod3-card-title">{{ card.title }}</div>
                <div class="mod3-card-subtitle">{{ activeCard === index ? card.subtitle.replace(/\n/g, '') : card.subtitle }}</div>
                <!-- 详情面板截图：仅激活卡片显示，素材为 download-3-panel-N.png -->
                <img v-if="activeCard === index" class="mod3-panel" :src="card.panel" alt="">
              </div>
            </div>
          </div>

          <!-- ============ 模块四：下载教程视频 ============ -->
          <div v-if="item.key === 'video'" class="mod4-layout">
            <h2 class="mod4-title">{{ $t('download.mod4Title') }}</h2>
            <div class="mod4-divider"></div>
            <p class="mod4-subtitle">{{ $t('download.mod4Subtitle') }}</p>
            <div class="video-list">
              <div class="video-card">
                <div class="video-player">
                  <video
                      class="video-content"
                      src="../assets/video/APP-download.mp4"
                      controls
                      preload="metadata"
                  >
                    {{ $t('download.videoNotSupport') }}
                  </video>
                </div>
                <div class="video-label">{{ $t('download.videoAndroid') }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'DownloadPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },      // 模块一：灰色背景
        { key: 'intro', className: 'module-intro' },    // 模块二：白色背景
        { key: 'feature', className: 'module-feature' } // 模块三：灰色背景
        // 模块四（下载教程视频）已隐藏
      ],
      visibleMap: {},
      observer: null,
      activeCard: 0   // 模块三当前展开的卡片索引，鼠标悬浮对应卡片时切换
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1024
    },
    // 模块三卡片配置：文案走 i18n，背景图与面板截图走本地素材
    mod3Cards() {
      const bgList = [
        require('../assets/images/download/download-3-1.png'),
        require('../assets/images/download/download-3-2.png'),
        require('../assets/images/download/download-3-3.png'),
        require('../assets/images/download/download-3-4.png')
      ]
      // 详情面板截图：英文版切换为 download-3-panel-N-INT.png，中文保持原图
      const panelList = this.$i18n.locale === 'en' ? [
        require('../assets/images/download/download-3-panel-1-INT.png'),
        require('../assets/images/download/download-3-panel-2-INT.png'),
        require('../assets/images/download/download-3-panel-3-INT.png'),
        require('../assets/images/download/download-3-panel-4-INT.png')
      ] : [
        require('../assets/images/download/download-3-panel-1.png'),
        require('../assets/images/download/download-3-panel-2.png'),
        require('../assets/images/download/download-3-panel-3.png'),
        require('../assets/images/download/download-3-panel-4.png')
      ]
      return bgList.map((bg, index) => ({
        bg,
        panel: panelList[index],
        title: this.stripNewlines(this.$t('download.mod3CardTitle' + (index + 1))),
        subtitle: this.stripNewlines(this.$t('download.mod3CardSubtitle' + (index + 1)))
      }))
    }
  },
  mounted() {
    // 滚动吸附由 App.vue 按断点统一管理
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    this.initObserver()
    // 模块三内层滚动到底后，下一次滑动触发页面切页
    this.$nextTick(() => {
      this.initMod3ScrollBridge()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.destroyMod3ScrollBridge()
  },
  methods: {
    // 手机端去掉 i18n 文案中的 \n，避免 white-space: normal 把 \n 折叠成空格
    stripNewlines(text) {
      return this.isMobile ? text.replace(/\n/g, '') : text
    },
    updateScale() {
      // 用有效屏幕尺寸（扣除安全区）计算缩放，避免内容超出安全区产生黑边
      const style = getComputedStyle(document.documentElement)
      const leftInset = parseFloat(style.getPropertyValue('--safe-left')) || 0
      const rightInset = parseFloat(style.getPropertyValue('--safe-right')) || 0
      const topInset = parseFloat(style.getPropertyValue('--safe-top')) || 0
      const bottomInset = parseFloat(style.getPropertyValue('--safe-bottom')) || 0
      const effectiveWidth = window.innerWidth - leftInset - rightInset
      const effectiveHeight = window.innerHeight - topInset - bottomInset
      const fit = Math.max(effectiveWidth / 1920, effectiveHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    },
    // 模块三内层滚动桥接：内层滚到底/顶后，允许页面级 scroll-snap 接管切页
    initMod3ScrollBridge() {
      const layout = this.$el.querySelector('.module-feature .mod3-layout')
      if (!layout) return
      this._mod3Layout = layout
      this._mod3TouchStartY = 0
      this._onMod3TouchStart = (e) => {
        this._mod3TouchStartY = e.touches[0].clientY
      }
      this._onMod3TouchMove = (e) => {
        const el = this._mod3Layout
        const deltaY = e.touches[0].clientY - this._mod3TouchStartY
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
        const atTop = el.scrollTop <= 0
        // 滚到底且继续下滑，或滚到顶且继续上滑 → 让页面级 scroll-snap 接管
        if ((atBottom && deltaY < 0) || (atTop && deltaY > 0)) {
          el.style.overflowY = 'visible'
        } else {
          el.style.overflowY = 'auto'
        }
      }
      this._onMod3TouchEnd = () => {
        if (this._mod3Layout) {
          this._mod3Layout.style.overflowY = 'auto'
        }
      }
      layout.addEventListener('touchstart', this._onMod3TouchStart, { passive: true })
      layout.addEventListener('touchmove', this._onMod3TouchMove, { passive: true })
      layout.addEventListener('touchend', this._onMod3TouchEnd, { passive: true })
    },
    destroyMod3ScrollBridge() {
      const layout = this._mod3Layout
      if (layout) {
        layout.removeEventListener('touchstart', this._onMod3TouchStart)
        layout.removeEventListener('touchmove', this._onMod3TouchMove)
        layout.removeEventListener('touchend', this._onMod3TouchEnd)
      }
    }
  }
}
</script>

<style scoped>
/* ============================================================
 * 页面级公共样式（整屏容器、画布、动效）
 * ============================================================ */

.download-page {
  padding-top: 0;
}

/* 全屏高度纵向模块，配合页面级 scroll-snap 实现整屏吸附切页 */
.fullscreen-section {
  height: 100vh;
  /* 手机端用 JS 实时写入的可见高度（App.vue），避免 100vh 高于可见区导致底部裁切；桌面不受影响 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
}

/* 设计稿画布：四个模块共用的固定尺寸容器，整体等比缩放 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateY(48px);
  /* 隐藏态不设过渡：切页离开瞬间重置，切回时子元素独立动效完整重播 */
  will-change: opacity, transform;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* ============================================================
 * 模块一：灰色背景
 * ============================================================ */

.module-hero {
  background: #DEDEDE;
}

.module-hero .mod1-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 模块一右侧手机图：改 height 调大小，改 right/top 调位置 */
.module-hero .mod1-phone {
  position: absolute;
  top: 56%;
  right: -90px;
  transform: none;
  height: 900px;
  width: 910px;
  object-fit: contain;
}

/* 模块一左侧文字区：改 left/top 调整整块位置 */
.module-hero .mod1-text {
  position: absolute;
  left: 400px;
  top: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* 仅英文生效且仅桌面端：左侧文字区单独调左右，改 left 值（移动端文字区为文档流布局，left 自动失效） */
:lang(en) .module-hero .mod1-text {
  left: 360px;
}

/* 模块一大标题（可孚孚探APP）：改 font-size 调大小 */
.module-hero .mod1-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 50px;
  color: #252525;
  line-height: 1.2;
  margin: 0;
}

/* 模块一副标题（持续葡萄糖监测应用）：改 font-size 调大小 */
.module-hero .mod1-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 38px;
  color: #252525;
  line-height: 1.2;
  margin-top: 24px;
}

/* 模块一介绍段落：改 font-size/line-height 调文字，改 max-width 调换行宽度 */
.module-hero .mod1-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #8C8C8C;
  line-height: 44px;
  max-width: 600px;
  margin: 40px 0 0 0;
  text-align: justify;
}

/* 仅英文生效：模块一介绍段落单独调大小和位置 */
/* 改 font-size 调字号，改 max-width 调换行宽度；改 transform 两个值（向右、向下）调位置，不影响二维码白块等其他元素 */
:lang(en) .module-hero .mod1-desc {
  font-size: 22px;
  max-width: 700px;
  transform: translate(0, -30px);
}

/* 模块一左下角二维码白块（仅包二维码图）：改 left/bottom 调位置，改 padding/border-radius 调白块大小和圆角 */
.module-hero .mod1-chapp {
  position: absolute;
  left: 400px;
  bottom: 260px;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 24px;
}

/* 仅英文生效且仅桌面端：二维码白块单独调左右，改 left 值（移动端为文档流布局 left 自动失效；内部二维码图跟随白块同步移动） */
:lang(en) .module-hero .mod1-chapp {
  left: 360px;
}

/* 二维码图：改 width 调大小 */
.module-hero .mod1-chapp-img {
  display: block;
  width: 108px;
  height: auto;
  object-fit: contain;
}

/* 二维码下方提示文字：改 left/bottom 调位置，改 font-size 调大小 */
/* width 与白块外宽一致（图128px+左右padding各20px=140px），配合居中使两行文字在二维码正下方对齐 */
.module-hero .mod1-chapp-tip {
  position: absolute;
  left: 421px;
  bottom: 200px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 550;
  font-size: 14px;
  color: #252525;
  line-height: 1.4;
  text-align: center;
  white-space: pre-line;   /* 语言包中的 \n 换行在此生效（扫码提示为两行） */
}

/* 仅英文生效且仅桌面端：二维码下方提示文字单独调左右，改 left 值（移动端为文档流布局 left 自动失效；初始 409px 为原 -12px 偏移的等效位置） */
:lang(en) .module-hero .mod1-chapp-tip {
  left: 372px;
}

/* ------------------------------------------------------------
 * 模块一动效独立拆分：左侧文字区、二维码白块、右侧手机图各自为一个动效，互不影响，
 * 透明度与父层 .section-inner 相乘生效；隐藏态不设过渡，切页离开瞬间重置，切回来完整重播，
 * 隐藏态保留各自布局 translate 基准，动画位移叠加在其后，不改变最终位置。
 * 每组调节点：改 0.8s 调动画时长，改末尾延迟调晚多久出现，改 translateY(24px) 调上移幅度。
 * 二维码组同时作用于白块与下方提示文字（.mod1-chapp / .mod1-chapp-tip），两者参数保持一致同步运动；
 * 英文版位置偏移走各 :lang(en) left 调节点，与动画 transform 互不影响，无需两态叠加。
 * ------------------------------------------------------------ */

/* 第1组：左侧文字区（.mod1-text，含大标题+副标题+介绍段落），延迟 0s */
.reveal-section .mod1-text {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-text {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第2组：二维码白块+下方提示文字一起入场，延迟 0.2s 错开 */
.reveal-section .mod1-chapp,
.reveal-section .mod1-chapp-tip {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-chapp,
.reveal-section.is-visible .mod1-chapp-tip {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第3组：右侧手机图（.mod1-phone），保留 translateY(-50%) 垂直居中基准；延迟 0.4s 错开 */
.reveal-section .mod1-phone {
  opacity: 0;
  transform: translateY(-50%) translateY(24px);
}

.reveal-section.is-visible .mod1-phone {
  opacity: 1;
  transform: translateY(-50%) translateY(0);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* ============================================================
 * 模块二：白色背景
 * ============================================================ */

.module-intro {
  background: #FFFFFF;
}

.module-intro .mod2-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 模块二顶部标题区：改 top 调整距顶部距离 */
.module-intro .mod2-header {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* 模块二大标题：改 font-size 调大小 */
.module-intro .mod2-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 700;
  font-size: 48px;
  color: #252525;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

/* 仅英文生效：模块二大标题（More Than Monitoring...）单独调字号，只改 font-size */
:lang(en) .module-intro .mod2-title {
  font-size: 36px;
}

/* 模块二标题下方分割线：改 width 调线宽 */
.module-intro .mod2-divider {
  width: 200px;
  height: 1px;
  background-color: #000000;
  margin-bottom: 10px;
}

/* 模块二副标题：改 font-size/max-width 调文字大小和换行宽度 */
/* white-space: pre-line 使语言包字符串中的 \n 强制换行生效 */
.module-intro .mod2-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #8C8C8C;
  line-height: 1.6;
  max-width: 900px;
  margin: 0;
  white-space: pre-line;
}

/* 模块二中间手机图：改 height 调大小 */
.module-intro .mod2-phone {
  position: absolute;
  left: 50%;
  top: 62%;
  transform: translate(-50%, -50%);
  height: 600px;
  width: auto;
  object-fit: contain;
}

/* 模块二功能说明文字：改 font-size 调大小，改 left/right/top/bottom 调位置 */
/* 悬挂缩进：padding-left 留出圆点位置，圆点用固定 1em 宽的盒子绘出，首行文字起点与换行行首精确对齐 */
/* white-space: pre-line 使语言包字符串中的 \n 强制换行生效（\n 换出的行同样与首行文字对齐） */
.module-intro .mod2-text {
  position: absolute;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #252525;
  line-height: 1.6;
  max-width: 380px;
  padding-left: 1em;
  white-space: pre-line;
}

/* 圆点符号：固定 1em 宽 + 负外边距使其不占流内宽度，绘在 padding 留出的位置 */
.module-intro .mod2-text::before {
  content: '•';
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

/* 左上文字 */
.module-intro .mod2-text-1 {
  left: 340px;
  top: 420px;
}

/* 右上文字 */
.module-intro .mod2-text-2 {
  right: 340px;
  top: 420px;
  z-index: 2;
}

/* 右下文字： */
.module-intro .mod2-text-3 {
  right: 340px;
  top: 730px;
}

/* 左下文字： */
.module-intro .mod2-text-4 {
  left: 340px;
  top: 640px;
}

/* 仅英文生效：模块二四条功能说明文字（feature1~4）单独调大小和位置 */
/* 大小：改 font-size 调字号，改 max-width 调换行宽度，四条一起变化 */
:lang(en) .module-intro .mod2-text {
  font-size: 18px;
  max-width: 420px;
}

/* 位置：每条单独调，改 top 调纵向位置，不影响手机图等其他元素 */
@media (min-width: 1025px) {
  :lang(en) .module-intro .mod2-text-1 {
    top: 400px;
  }

  :lang(en) .module-intro .mod2-text-2 {
    top: 400px;
  }

  :lang(en) .module-intro .mod2-text-3 {
    top: 696px;
  }

  :lang(en) .module-intro .mod2-text-4 {
    top: 620px;
  }
}

/* 模块二左上截图：改 width 调大小，改 left/top 调位置 */
.module-intro .mod2-card-1 {
  position: absolute;
  left: 460px;
  top: 490px;
  width: 240px;
  height: auto;
}

/* 模块二右上截图：改 width 调大小，改 right/top 调位置 */
.module-intro .mod2-card-2 {
  position: absolute;
  right: 480px;
  top: 490px;
  width: 230px;
  height: auto;
  z-index: 1;
}

/* 模块二右下截图 */
.module-intro .mod2-card-3 {
  position: absolute;
  right: 410px;
  top: 800px;
  width: 300px;
  height: auto;
}

/* 模块二左下截图 */
.module-intro .mod2-card-4 {
  position: absolute;
  left: 470px;
  top: 705px;
  width: 220px;
  height: auto;
}

/* 仅英文生效（电脑端）：英文版专属位置调节点 */
@media (min-width: 1025px) {
  /* 英文版：左上截图 */
  :lang(en) .module-intro .mod2-card-1 {
    left: 430px;
    top: 470px;
  }

  /* 英文版：右上截图 */
  :lang(en) .module-intro .mod2-card-2 {
    right: 480px;
    top: 470px;
  }

  /* 英文版：右下截图 */
  :lang(en) .module-intro .mod2-card-3 {
    right: 410px;
    top: 800px;
  }

  /* 英文版：左下截图 */
  :lang(en) .module-intro .mod2-card-4 {
    left: 440px;
    top: 710px;
  }

  /* 英文版：中间手机图（left: 50% 为水平居中基准，保持不动） */
  :lang(en) .module-intro .mod2-phone {
    top: 62%;
  }
}


/* ------------------------------------------------------------
 * 模块二动效独立拆分：中间手机图从小到大（缩放）入场，四张截图连带各自的功能说明文字
 * 一起从所在角方向移入（左上：图1+文字1；右上：图2+文字2；右下：图3+文字3；左下：图4+文字4，
 * ------------------------------------------------------------ */

/* 中间手机图（.mod2-phone）：从小到大，保留 translate(-50%, -50%) 居中基准，延迟 0s */
.reveal-section .mod2-phone {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}

.reveal-section.is-visible .mod2-phone {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
  transition: opacity 0.8s ease 0s,
    transform 0.8s ease 0s;
}

/* 第1组：左上截图+左上文字（.mod2-card-1 / .mod2-text-1），从左上方向右下移入 */
.reveal-section .mod2-card-1,
.reveal-section .mod2-text-1 {
  opacity: 0;
  transform: translate(-40px, -40px);
}

.reveal-section.is-visible .mod2-card-1,
.reveal-section.is-visible .mod2-text-1 {
  opacity: 1;
  transform: translate(0, 0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第2组：图2+文字2，从右上方向左下移入（右上） */
.reveal-section .mod2-card-2,
.reveal-section .mod2-text-2 {
  opacity: 0;
  transform: translate(40px, -40px);
}

.reveal-section.is-visible .mod2-card-2,
.reveal-section.is-visible .mod2-text-2 {
  opacity: 1;
  transform: translate(0, 0);
  transition: opacity 0.8s ease 0.2s,
    transform 0.8s ease 0.2s;
}

/* 第3组：图3+文字3，位置对调后位于右下，从右下方向左上移入（右下） */
.reveal-section .mod2-card-3,
.reveal-section .mod2-text-3 {
  opacity: 0;
  transform: translate(40px, 40px);
}

.reveal-section.is-visible .mod2-card-3,
.reveal-section.is-visible .mod2-text-3 {
  opacity: 1;
  transform: translate(0, 0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s;
}

/* 第4组：图4+文字4，位置对调后位于左下，从左下方向右上移入（左下） */
.reveal-section .mod2-card-4,
.reveal-section .mod2-text-4 {
  opacity: 0;
  transform: translate(-40px, 40px);
}

.reveal-section.is-visible .mod2-card-4,
.reveal-section.is-visible .mod2-text-4 {
  opacity: 1;
  transform: translate(0, 0);
  transition: opacity 0.8s ease 0.4s,
    transform 0.8s ease 0.4s;
}


/* ============================================================
 * 模块三：灰色背景
 * ============================================================ */

.module-feature {
  background: #F5F5F5;
}

.module-feature .mod3-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 模块三标题：改 font-size 调大小，改 margin-bottom 调与分割线的间距 */
.module-feature .mod3-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 48px;
  color: #252525;
  line-height: 1.2;
  margin: 40px 0 40px 0;
}

:lang(en) .module-feature .mod3-title {
  font-size: 48px;
    margin: 60px 0 30px 0;
}

/* 模块三标题下方分割线：改 width 调线宽 */
.module-feature .mod3-divider {
  width: 360px;
  height: 1px;
  background-color: #000000;
  margin-bottom: 16px;
}

/* 模块三副标题：灰色说明文字 */
.module-feature .mod3-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #B3B3B3;
  line-height: 1.6;
  max-width: 900px;
  margin: 0 0 70px 0;
  text-align: center;
}

/* 四卡片手风琴布局：改 gap 调卡片间距 */
.module-feature .mod3-list {
  display: flex;
  gap: 26px;
  align-items: stretch;
}

/* 单张卡片：改 height 调高度，宽度由 active 状态控制 */
.module-feature .mod3-card {
  position: relative;
  width: 200px;
  height: 460px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.3s ease;
  flex-shrink: 0;
}

/* 激活卡片横向展开 */
.module-feature .mod3-card.active {
  width: 640px;
}

/* 卡片背景图（download-3-N.png）：object-fit: cover 铺满裁切，object-position: left 从最左侧开始显示 */
.module-feature .mod3-card-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left;
  transition: filter 0.1s ease;
  z-index: 0;
}

/* 详情面板截图（download-3-panel-N.png）：仅激活卡片显示，位于左下区域 */
.module-feature .mod3-panel {
  position: absolute;
  left: 20px;
  top: 180px;
  width: 260px;
  border-radius: 12px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1;
}

.module-feature .mod3-card.active .mod3-panel {
  opacity: 1;
  transform: translateY(0);
}

/* 四张详情面板截图独立调节点：改 width 调大小，改 left/top 调位置 */
/* 卡片1：每日分析 */
.module-feature .mod3-card:nth-child(1) .mod3-panel {
  left: 38px;
  top: 180px;
  width: 300px;
}
:lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel {
  left: 20px;
  top: 180px;
  width: 300px;
}

/* 卡片2：周期回顾 */
.module-feature .mod3-card:nth-child(2) .mod3-panel {
  left: 38px;
  top: 200px;
  width: 280px;
}
:lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel {
  left: 20px;
  top: 200px;
  width: 280px;
}

/* 卡片3：异常提醒 */
.module-feature .mod3-card:nth-child(3) .mod3-panel {
  left: 38px;
  top: 190px;
  width: 290px;
}
:lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel {
  left: 20px;
  top: 190px;
  width: 300px;
}

/* 卡片4：数据导出 */
.module-feature .mod3-card:nth-child(4) .mod3-panel {
  left: 38px;
  top: 180px;
  width: 260px;
}
:lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
  left: 20px;
  top: 180px;
  width: 280px;
}

/* 卡片标题：改 left/top/font-size 调位置和大小 */
.module-feature .mod3-card-title {
  position: absolute;
  left: 0px;
  right: auto;
  width: 200px;
  text-align: center;
  top: 35px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 38px;
  color: #FFFFFF;
  line-height: 1.0;
  z-index: 3;
  transition: none;
}

/* 展开卡片标题：取消居中，改为左对齐 */
.module-feature .mod3-card.active .mod3-card-title {
  left: 24px;
  right: auto;
  text-align: left;
  transition: none;
}

/* 仅英文生效：卡片标题英文文案更长，字号收窄防溢出 */
:lang(en) .module-feature .mod3-card-title {
  font-size: 22px;
  max-width: 200px;
  left: 20px;
  right: auto;
  text-align: left;
}

:lang(en) .module-feature .mod3-card.active .mod3-card-title {
  left: 20px;
  text-align: left;
  transition: none;
}

/* 卡片副标题：未激活时 white-space: pre-line 识别 \n 换行；激活时 white-space: normal 自然换行不识别 \n */
.module-feature .mod3-card-subtitle {
  position: absolute;
  left: 28px;
  right: 0;
  top: 90px;
  max-width: 200px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
  white-space: pre-line;
  text-align: left;
  z-index: 3;
  transition: none;
}

/* 激活卡片副标题：放宽宽度，取消居中改为左对齐 */
.module-feature .mod3-card.active .mod3-card-subtitle {
  left: 28px;
  right: auto;
  width: 600px;
  max-width: 540px;
  white-space: normal;
  text-align: left;
  transition: none;
}

/* 仅英文生效：卡片副标题英文文案更长，放宽 max-width 避免过早换行 */
:lang(en) .module-feature .mod3-card-subtitle {
  max-width: 160px;
  font-size: 20px;
    left: 20px;
    top: 78px;
    text-align: left;
}

:lang(en) .module-feature .mod3-card.active .mod3-card-subtitle {
  max-width: 520px;
  font-size: 20px;
  left: 20px;
  transition: none;
}

/* 悬停时背景微微提亮 */
.module-feature .mod3-card:hover .mod3-card-bg {
  filter: brightness(1.06);
}

/* ============================================================
 * 模块四：下载教程视频
 * ============================================================ */

.module-video {
  background: #FFFFFF;
}

.module-video .mod4-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* 模块四标题：改 font-size 调大小，改 margin-bottom 调与分割线的间距 */
.module-video .mod4-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 700;
  font-size: 48px;
  color: #252525;
  line-height: 1.8;
  margin: 40px 0 16px 0;
}

/* 模块四标题下方分割线：改 width 调线宽 */
.module-video .mod4-divider {
  width: 400px;
  height: 1px;
  background-color: #000000;
  margin-bottom: 30px;
}

/* 模块四副标题：灰色说明文字 */
.module-video .mod4-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #8C8C8C;
  line-height: 1.6;
  margin: 0 0 50px 0;
  text-align: center;
}

/* 三个视频卡片并排：改 gap 调卡片间距 */
.module-video .video-list {
  display: flex;
  justify-content: center;
  gap: 100px;
}

/* 单个视频卡片外壳：改 width 调卡片宽窄 */
.module-video .video-card {
  width: 1000px;
  background: #F5F5F5;
  border-radius: 16px;
  overflow: hidden;
}

/* 视频播放区：改 height 调视频区高矮 */
.module-video .video-player {
  width: 100%;
  height: 500px;
  background: #C0C0C0;
  position: relative;
}

.module-video .video-content {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  background-color: #000 !important;
}

/* 卡片下方标签文字：改 font-size 调大小 */
.module-video .video-label {
  padding: 20px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #252525;
  line-height: 28px;
  text-align: center;
}

/* ============================================================
 * 页脚与动效降级
 * ============================================================ */

.download-page >>> .footer {
  scroll-snap-align: end;
}






/* ============================================================
 * 移动端适配（<= 1024px）骨架：禁用画布缩放，由页面级媒体查询逐步接管模块布局，
 * !important 覆盖行内 transform（JS 缩放值）
 * ============================================================ */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 全部流式项禁止被 flex 压缩：内容总高超出整屏时，
     细元素（1px 分割线等）会被默认收缩直接压成 0 而消失，
     超出部分应落到底部裁切区而不是压缩内容 */
  .download-page .section-inner * {
    flex-shrink: 0;
  }

  /* ---------- 模块一：灰色背景 ---------- */

  /* 布局容器：垂直居中改顶对齐 + padding-top 预留固定导航栏，绝对定位子项改文档流纵向堆叠 */
  .module-hero .mod1-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  /* 左侧文字区：绝对定位改文档流，整体居中（改 padding 调两侧留白） */
  .module-hero .mod1-text {
    position: static;
    align-items: center;
    padding: 0 6%;
    text-align: center;
  }

  .module-hero .mod1-title {
    font-size: 9vw;
  }

  .module-hero .mod1-subtitle {
    font-size: 7vw;
    margin-top: 1vh;
  }

  .module-hero .mod1-desc {
    font-size: 5vw;
    line-height: 1.2;
    max-width: none;      /* max-width: 80vw;   不同手机都按屏宽 80% 换行，换行位置一致 */
    margin: 2vh 0 0 0;
    text-align: justify;
  }

  /* 英文版：去掉桌面上移偏移，字号单独换算 */
  :lang(en) .module-hero .mod1-subtitle {
    font-size: 5vw;
  }

  :lang(en) .module-hero .mod1-desc {
    font-size: 4vw;
    transform: none;
  }

  /* 二维码白块：绝对定位改文档流（改 .mod1-chapp-img 的 width 调二维码大小，改 padding 调白块留白） */
  .module-hero .mod1-chapp {
    position: static;
    margin-top: 3vh;
    padding: 2vh;
    border-radius: 3vw;
  }

  .module-hero .mod1-chapp-img {
    width: 16vh;
  }

  /* 二维码下方提示文字：绝对定位改文档流 */
  .module-hero .mod1-chapp-tip {
    position: static;
    margin-top: 1.5vh;
    font-size: 3.73vw;
  }

  /* 右侧手机图：绝对定位改文档流放底部，改 height 调大小 */
  .module-hero .mod1-phone {
    position: static;
    height: 32vh;
    width: auto;
    margin-top: 0vh;
    margin-left: 22vw;
    transform: none;
  }

    :lang(en) .module-hero .mod1-phone {
      height: 32vh;
        margin-top: 0vh;
        margin-left: 20vw;
    }


  /* 动效位移配对覆盖：桌面手机图带 translateY(-50%) 居中基准，手机端两态都要覆盖，否则入场时位置跳变 */
  .reveal-section .mod1-phone {
    transform: translateY(24px);
  }

  .reveal-section.is-visible .mod1-phone {
    transform: translateY(0);
  }

  /* ---------- 模块二：白色背景（标题在上，三列在下：1/3左 | 手机 | 2/4右） ---------- */

  /* 布局容器：标题独占一行，下方三列 flex 不换行 */
  .module-intro .mod2-layout {
    display: flex;
    flex-direction: column;
    padding: 4vh 4vw 2vh 4vw;
  }

  /* 标题区*/
  .module-intro .mod2-header {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    text-align: center;
    margin-bottom: 4vh;
  }

  .module-intro .mod2-title {
    font-size: 5.33vw;
    margin: -3vh 0 1vh 0;
  }

  :lang(en) .module-intro .mod2-title {
    font-size: 4.53vw;
    margin: 3vh 0 1vh 0;
  }

  .module-intro .mod2-divider {
    width: 36vw;
    margin: 0 auto 1vh;
  }

  .module-intro .mod2-subtitle {
    font-size: 3.2vw;
    max-width: 80vw;
    white-space: normal;
  }

  :lang(en) .module-intro .mod2-subtitle {
    max-width: 90vw;
  }

  /* 下方三列容器：横向 flex 不换行 */
  .module-intro .mod2-cols {
    display: flex;
    align-items: flex-start;
    gap: 2vh;
  }

  /* 左右列：纵向排列内部图文 */
  .module-intro .mod2-col-left,
  .module-intro .mod2-col-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2vh;
  }

  /* 中间列：手机图垂直居中 */
  .module-intro .mod2-col-center {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* 手机图 */
  .module-intro .mod2-phone {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    height: 40vh;        /* 改这个调手机图大小 */
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }

  /* 四条文字：覆盖桌面 absolute + 圆点；强制 opacity:1 避免桌面动效隐藏态残留 */
  .module-intro .mod2-text {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    font-size: 2.8vw;
    width: 100%;
    max-width: none;
    line-height: 1.5;
    white-space: normal;
    text-align: center;
    padding-left: 0;
    opacity: 1 !important;   /* 强制可见，覆盖桌面端动画 opacity:0 */
  }

  .module-intro .mod2-text::before {
    display: none;
  }

  :lang(en) .module-intro .mod2-text {
    font-size: 2.6vw;
  }

  /* 四张截图：覆盖桌面 absolute */
  .module-intro .mod2-card-1,
  .module-intro .mod2-card-2,
  .module-intro .mod2-card-3,
  .module-intro .mod2-card-4 {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    width: auto;
    object-fit: contain;
  }

  .module-intro .mod2-card-1 { max-height: 7vh; }
  .module-intro .mod2-card-2 { max-height: 12vh; }
  .module-intro .mod2-card-3 { max-height: 6vh; }
  .module-intro .mod2-card-4 { max-height: 16vh; }

  /*
   * 三列布局：
   *
   *   [标题区 - 占满整行]
   *   [col-left: 1+4]  [phone]  [col-right: 3+2]
   */

  /* 手机图动效：去掉桌面 translate(-50%,-50%) 居中基准，只保留缩放 */
  .reveal-section .mod2-phone {
    opacity: 0;
    transform: scale(0.8);
  }

  .reveal-section.is-visible .mod2-phone {
    opacity: 1;
    transform: scale(1);
    transition: opacity 0.8s ease 0s,
      transform 0.8s ease 0s;
  }

  /* 四组图文动效：与桌面端一致，从四个角方向移入 */
  /* 第1组：图1+文字1，从左上方向右下移入 */
  .reveal-section .mod2-card-1,
  .reveal-section .mod2-text-1 {
    opacity: 0;
    transform: translate(-40px, -40px);
  }
  .reveal-section.is-visible .mod2-card-1,
  .reveal-section.is-visible .mod2-text-1 {
    opacity: 1;
    transform: translate(0, 0);
    transition: opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s;
  }

  /* 第2组：图2+文字2，从右下方向左上移入（右列下） */
  .reveal-section .mod2-card-2,
  .reveal-section .mod2-text-2 {
    opacity: 0;
    transform: translate(40px, 40px);
  }
  .reveal-section.is-visible .mod2-card-2,
  .reveal-section.is-visible .mod2-text-2 {
    opacity: 1;
    transform: translate(0, 0);
    transition: opacity 0.8s ease 0.4s, transform 0.8s ease 0.4s;
  }

  /* 第3组：图3+文字3，从右上方向左下移入（右列上） */
  .reveal-section .mod2-card-3,
  .reveal-section .mod2-text-3 {
    opacity: 0;
    transform: translate(40px, -40px);
  }
  .reveal-section.is-visible .mod2-card-3,
  .reveal-section.is-visible .mod2-text-3 {
    opacity: 1;
    transform: translate(0, 0);
    transition: opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s;
  }

  /* 第4组：图4+文字4，从左下方向右上移入（左列下） */
  .reveal-section .mod2-card-4,
  .reveal-section .mod2-text-4 {
    opacity: 0;
    transform: translate(-40px, 40px);
  }
  .reveal-section.is-visible .mod2-card-4,
  .reveal-section.is-visible .mod2-text-4 {
    opacity: 1;
    transform: translate(0, 0);
    transition: opacity 0.8s ease 0.4s, transform 0.8s ease 0.4s;
  }

  /* 英文版：四条文字两态保留各自位置偏移，叠加动画位移 */
  :lang(en) .reveal-section .mod2-text-1 {
    transform: translate(0, 0) translate(-40px, -40px);
  }
  :lang(en) .reveal-section.is-visible .mod2-text-1 {
    transform: translate(0, 0);
  }

  :lang(en) .reveal-section .mod2-text-2 {
    transform: translate(0, 0) translate(40px, 40px);
  }
  :lang(en) .reveal-section.is-visible .mod2-text-2 {
    transform: translate(0, 0);
  }

  :lang(en) .reveal-section .mod2-text-3 {
    transform: translate(0, 0) translate(40px, -40px);
  }
  :lang(en) .reveal-section.is-visible .mod2-text-3 {
    transform: translate(0, 0);
  }

  :lang(en) .reveal-section .mod2-text-4 {
    transform: translate(0, 0) translate(-40px, 40px);
  }
  :lang(en) .reveal-section.is-visible .mod2-text-4 {
    transform: translate(0, 0);
  }

  /* ---------- 模块三：灰色背景 ---------- */

  /* 模块三内部布局：允许内容溢出滚动，不压缩卡片 */
  .module-feature .mod3-layout {
    justify-content: flex-start;
    padding-top: 10vh;
    padding-bottom: 6vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    box-sizing: border-box;
  }

  /* 模块三标题：改 font-size 调大小 */
  .module-feature .mod3-title {
    font-size: 6.4vw;
    margin: 0 0 2vh 0;
    text-align: center;
  }

  :lang(en) .module-feature .mod3-title {
    font-size: 5.5vw;
    margin: 2vh 0 2vh 0;
  }

  /* 标题下方分割线 */
  .module-feature .mod3-divider {
    width: 40vw;
    margin-bottom: 1vh;
  }

  /* 模块三副标题：改 font-size 调大小 */
  .module-feature .mod3-subtitle {
    font-size: 4.27vw;
    max-width: none;
    padding: 0 6%;
    margin: 0 0 2vh 0;
    text-align: justify;
  }

  :lang(en) .module-feature .mod3-subtitle {
    font-size: 4.27vw;
       line-height: 1.3;
    margin: 0 0 2vh 0;
  }

  /* 四卡片：横向手风琴改纵向堆叠，激活卡片展开高度（改 height 调收起/展开高矮） */
  .module-feature .mod3-list {
    flex-direction: column;
    align-items: center;
    gap: 2vh;
    width: 100%;
  }

  /* 卡片收起/展开：改 height 调高矮 */
  .module-feature .mod3-card {
    width: 88%;
    height: 14vh;
    transition: height 0.3s ease;
  }

  .module-feature .mod3-card.active {
    width: 88%;
    height: 29vh;
  }

  /* 卡片标题：改 font-size 调大小 */
  .module-feature .mod3-card-title {
    left: 4vw;
    top: 1.5vh;
    font-size: 4.8vw;
    text-align: left;
  }

  :lang(en) .module-feature .mod3-card-title {
    font-size: 4.6vw;
    top: 1.5vh;
    left: 5vw;
  }
  /* 卡片标题展开状态：改 left/top 调位置 */
  .module-feature .mod3-card.active .mod3-card-title {
    left: 4vw;
    top: 1.5vh;
  }

  :lang(en) .module-feature .mod3-card.active .mod3-card-title {
    left: 5vw;
    top: 1.5vh;
  }

  /* 卡片副标题：改 font-size 调大小 */
  .module-feature .mod3-card-subtitle {
    left: 4vw;
    top: 5.5vh;
    max-width: 70%;
    line-height: 1.3;
    font-size: 3.5vw;
  }

  .module-feature .mod3-card.active .mod3-card-subtitle {
    left: 4vw;
    text-align: left;
    max-width: 85%;
  }

  :lang(en) .module-feature .mod3-card-subtitle {
    left: 5vw;
    top: 5.3vh;
    max-width: 70%;
    font-size: 3.7vw;
  }

  :lang(en) .module-feature .mod3-card.active .mod3-card-subtitle {
    max-width: 85%;
    font-size: 3.7vw;
    left: 5vw;
  }

  /* 详情面板：收进展开后的卡片内（改 width 调大小，改 top 调纵向位置） */
  .module-feature .mod3-card:nth-child(1) .mod3-panel,
  .module-feature .mod3-card:nth-child(2) .mod3-panel,
  .module-feature .mod3-card:nth-child(3) .mod3-panel,
  .module-feature .mod3-card:nth-child(4) .mod3-panel {
    left: 4vw;
    top: 11vh;
    width: 40vw;
  }

  :lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
    left: 4vw;
    top: 11vh;
    width: 40vw;
  }

  /* 卡片1、4的小图与小字间距单独调：改 top 调小图纵向位置（值越大离小字越远） */
  .module-feature .mod3-card:nth-child(1) .mod3-panel,
  .module-feature .mod3-card:nth-child(4) .mod3-panel {
    top: 10vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
    top: 11vh;
  }

  /* 卡片2、3的小图与小字间距单独调：改 top 调小图纵向位置 */
  .module-feature .mod3-card:nth-child(2) .mod3-panel,
  .module-feature .mod3-card:nth-child(3) .mod3-panel {
    top: 12vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel {
    top: 14vh;
  }

  /* ---------- 模块四：下载教程视频 ---------- */

  .module-video .mod4-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  .module-video .mod4-title {
    font-size: 6.4vw;
    line-height: 1.3;
    margin: 0 0 2vh 0;
  }

  .module-video .mod4-divider {
    width: 50vw;
    margin-bottom: 2vh;
  }

  .module-video .mod4-subtitle {
    font-size: 4.8vw;
    padding: 0 10%;
    margin: 0 0 3vh 0;
  }

  /* 视频卡：通栏纵向（改 .video-player 的 height 调视频区高矮） */
  .module-video .video-list {
    flex-direction: column;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
    gap: 3vh;
  }

  .module-video .video-card {
    width: 100%;
  }

  .module-video .video-player {
    height: 42vh;
  }

  .module-video .video-label {
    padding: 1.5vh;
    font-size: 4.8vw;
    line-height: 1.4;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
